// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__vNs6H","header":"MergedInvoice_header__3RFmm"};